module.exports = "/images/reporteZonas.svg";